<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <b-row class="mt-2">
      <b-col md="8">
        <h2>{{ $t("tracking.cargo.data") }}</h2>
        <!-- cargoId -->
        <base-row-detail
          :label="`${$t('tracking.cargoExpense.model.cargo')} :`"
          :value="`${this.cargo.cargoId}`"
        ></base-row-detail>

        <!-- clientName -->
        <base-row-detail
          :label="`${$t('tracking.cargo.clientName')} :`"
          :value="this.cargo.clientName"
        ></base-row-detail>

        <!-- branchName -->
        <base-row-detail
          :label="`${$t('tracking.cargo.companyBranchName')} :`"
          :value="this.cargo.companyBranchName"
        ></base-row-detail>

        <!-- driverName -->
        <base-row-detail
          :label="`${$t('tracking.cargo.driverName')} :`"
          :value="this.cargo.driver"
        ></base-row-detail>

        <!-- transportNumber -->
        <base-row-detail
          :label="`${$t('tracking.cargo.transportNumber')} :`"
          :value="this.cargo.transportNumber"
        ></base-row-detail>
        <!-- <div>{{cargo}}</div> -->
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <h2>{{ $t("tracking.cargoExpense.list") }}</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <router-link :to="`/trackingShippingCompany/cargo/list/`">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
        <router-link
          class="ml-2"
          :to="`/trackingShippingCompany/cargoExpense/create/${cargoId}`"
        >
          <b-button size="sm">{{ $t("tracking.cargoExpense.new") }}</b-button>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          ref="table"
          class="table-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :filter="tableFilters"
          :filter-debounce="500"
          :per-page="tablePerPage"
          :current-page="tableCurrentPage"
        >
          <!-- <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="tableFilters[field.filterKey] != null">
                <b-form-input
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template> -->

          <template v-slot:cell(actions)="data">
            <div v-if="tableRowCount.permissions == 1">
              <router-link :to="getUrlEdit(data.item)">
                <b-button size="sm" class="btn-checklist">
                  {{ $t("geral.edit") }}
                </b-button>
              </router-link>
            </div>
            <router-link :to="getUrlEdit(data.item)">
              <b-button size="sm" class="btn-checklist">
                {{ $t("geral.detalhes") }}
              </b-button>
            </router-link>
            <!-- 
          <b-button
            size="sm"
            class="btn-checklist ml-2"
            @click="vechicleTypeDeactivate(data.item)"
          >
            {{ $t("geral.delete") }}
          </b-button> -->
          </template>
        </b-table>
      </b-col>
    </b-row>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>

    <!-- <pre class="language-json"><code>{{ fields  }}</code></pre> -->
  </b-container>
</template>

<script>
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";

export default {
  name: "CargoExpenseList",
  components: {
    BaseRowDetail,
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
  },
  props: {
    cargoId: String,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      cargo: null,
      isBusy: false,
      fields: [
        {
          key: "actions",
          // sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "cargoExpenseId",
          filterKey: "cargoExpenseId",
          // sortable: false,
          label: this.$t("tracking.cargoExpense.model.expense"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "date",
          filterKey: "date",
          label: this.$t("tracking.cargoExpense.model.date"),
          // sortable: true,
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            let strDate = `${item.date}T00:00:00`;
            let date = new Date(strDate);
            return date.toLocaleDateString();
          },
        },
        {
          key: "value",
          filterKey: "value",
          label: this.$t("tracking.cargoExpense.model.value"),
          // sortable: true,
          tdClass: "table-col-dinamic-width-numeric",
          formatter: (value, key, item) => {
            return value.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            });
          },
        },
        {
          key: "cargoExpenseTypeDescription",
          filterKey: "cargoExpenseTypeDescription",
          label: this.$t("tracking.cargoExpenseType.model.description"),
          // sortable: true,
        },
        {
          filterKey: "currentOccurrence",
          key: "currentOccurrence",
          label: this.$t("tracking.cargoExpense.model.currentOccurrence"),
        },
        {
          key: "responsability",
          filterKey: "responsability",
          label: this.$t("tracking.cargoExpense.model.responsability"),
          // sortable: true,
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            if (value == 1) return this.$t("geral.company");
            if (value == 2) return this.$t("geral.client");
            return "aa";
          },
        },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        branchName: "",
        cargoId: "",
        cargoExpenseId: "",
        cargoExpenseTypeDescription: "",
        clientName: "",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {
    this.loadCargo();
  },
  computed: {},
  methods: {
    getUrlEdit(cargo) {
      return `/trackingShippingCompany/cargoExpense/edit/${cargo.cargoExpenseId}`;
    },
    async loadCargo() {
      await this.$api
        .get(`/cargo/get/${this.cargoId}`)
        .then((response) => {
          let model = response.data;
          // model.weight = model.weight.toFixed(2);
          this.cargo = model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        cargoId: this.cargoId,
        // statusDescription: ctx.filter.statusDescription,
        // clientName: ctx.filter.clientName,
        // dateDeliveryForecastBegin: ctx.filter.dateDeliveryForecast,
        // dateDeliveryForecastEnd: ctx.filter.dateDeliveryForecast,
        // originCityName: ctx.filter.originCityName,
        // destinationCityName: ctx.filter.destinationCityName,
      };

      this.$api
        .post("/v1/cargoExpense/all", apiParam)
        .then((response) => {
          const items = response.data.items;
          // console.log("ok")
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          // console.log(this.tableRowCount)
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    cargoActivate(cargo) {
      this.$api
        .get("/cargo/activate/" + cargo.cargoId.toString())
        .then((response) => {
          cargo.cargoActive = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    vechicleTypeDeactivate(cargo) {
      this.$api
        .get("/cargo/deactivate/" + cargo.cargoId.toString())
        .then((response) => {
          cargo.cargoActive = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

<style scoped>
.btn-checklist {
  min-width: 95px;
}
</style>